<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const online = ref(
  typeof navigator === "undefined" || navigator.onLine !== false,
);

function syncStatus() {
  online.value = navigator.onLine !== false;
}

onMounted(() => {
  window.addEventListener("online", syncStatus);
  window.addEventListener("offline", syncStatus);
  syncStatus();
});

onBeforeUnmount(() => {
  window.removeEventListener("online", syncStatus);
  window.removeEventListener("offline", syncStatus);
});
</script>

<template>
  <div
    v-if="!online"
    class="connectivity-banner"
    role="alert"
    aria-live="polite"
  >
    <strong>当前处于离线状态</strong>
    <span>已加载的内容仍可浏览；恢复网络后可重新请求直播和实时数据。</span>
  </div>
</template>
